<template>
  <div v-if="fieldData.visible" :id="fieldData.field_name + '_block'" class="field-display px-3">
    <div class="row">
      <template v-if="fieldData.field_type === 'LinkButtonList'">
        <input-link-button-list :pdfLinkCovData="pdfLinkCov"></input-link-button-list>
      </template>
      <template v-else>
        <div v-if="fieldData['label']" class="col-6 mb-2 font-weight-bold">{{ fieldData['label'] }}</div>
        <div :class="fieldData['label'] ? 'col-6 mb-2' : 'col-md-12 mb-3'" v-html="fieldValue(fieldData)"></div>
      </template>
    </div>
  </div>
</template>

<script>
import InputLinkButtonList from '../interactive/InputLinkButtonList';
// TODO: Remove eslint
/* eslint-disable */
export default {
  props: ['fieldData'],
  components: {
    InputLinkButtonList,
  },
  data() {
    return {
      pdfLinkCov: [],
    };
  },
  created() {
    if(this.fieldData.fields) {
      // collect policy level and vehicle level coverage data
      for (let cnt = 0; cnt < this.fieldData.fields.length; cnt += 1) {
        if (this.fieldData.fields[cnt].field_type === 'LinkButtonList') {
          this.pdfLinkCov.push(this.fieldData.fields[cnt]);
        }
      }
    } else if(this.fieldData && this.fieldData.field_type === 'LinkButtonList') {
      this.pdfLinkCov.push(this.fieldData);
    }
      
  },
  methods: {
    /**
     * The value is either the `field_value`, or, if it has items in the
     * `values` array, then find the matching item, and display its `disaply_value`.
     */
    fieldValue(fieldData) {
      let fieldValue = fieldData.field_value;

      fieldData.values.forEach((value) => {
        if (value.internal_value === fieldValue) {
          fieldValue = value.display_value; // Use its matching display value
        }
      });

      return fieldValue; // No values list, so use the `field_value` value
    },
  },
};
</script>

<style scoped>
label {
  display: inline-block;
  margin-bottom: 0.25rem;
  font-weight: 600;
  max-width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/FieldDisplay.vue?46a013a2